var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center px-2"},[_c('v-btn',{attrs:{"loading":_vm.loading,"small":"","icon":""},on:{"click":function($event){return _vm.scan()}}},[_c('v-icon',{staticClass:"barcode-icon",attrs:{"medium":""}},[_vm._v(" mdi-barcode-scan ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }